import { createFileRoute } from '@tanstack/react-router'

import { MENU } from '@/constants/common/message.constants'

export const Route = createFileRoute(
  '/_protected/$tenantKey/settings/plan-slots'
)({
  meta: () => [{ title: MENU.PERMANENT_VEHICLES }]
})
